import { combineReducers } from 'redux';
import pageHeaderReducer from '../../components/page-header/page-header-reducer';
import pageFooterReducer from '../../components/page-footer/page-footer-reducer';
import wholeClassReducer from '../../containers/whole-class/whole-class-reducer';
import studentsReducer from '../../containers/students/students-reducer';
import confirmationModalReducer from '../confirmation-modal/confirmation-modal-reducer';
import busyIndicatorReducer from '../../components/busy-indicator/busy-indicator-reducer';
import toastReducer from '../../components/toast/reducer';

const CombinedReducers = combineReducers({
    busyIndicatorReducer,
    pageHeaderReducer,
    pageFooterReducer,
    wholeClassReducer,
    studentsReducer,
    confirmationModalReducer,
    toastReducer
});

export default CombinedReducers;



// WEBPACK FOOTER //
// ./containers/app/combined-reducers.js